<template>
  <div class="mysql-instanceBackup-page">
    <Modal
      v-model="manualBackupModal"
      title="手动备份"
      width="1000"
      @on-ok="manualBackupSubmit"
      @on-cancel="manualBackupCancel">
      <i-form ref="manualBackupForm" :model="manualBackupForm" :label-width="80">
        <form-item label="备份方式" prop="backup_method">
          <Select style="width:100%" v-model="manualBackupForm.backup_method">
            <Option :value=1 label="物理备份"></Option>
            <Option :value=2 label="逻辑备份"></Option>
          </Select>
        </form-item>
        <form-item v-if="manualBackupForm.backup_method === 2" label="备份时间" prop="backup_type">
          <RadioGroup v-model="manualBackupForm.backup_type">
            <Radio :label="1">
              <span>实例备份</span>
            </Radio>
            <Radio :label="2">
              <span>单库备份</span>
            </Radio>
          </RadioGroup>
        </form-item>
        <form-item v-if="manualBackupForm.backup_type === 2 && manualBackupForm.backup_method === 2" label="数据库" prop="backup_db">
          <transfer
            :data="databaseList"
            :list-style="listStyle"
            :target-keys="manualBackupForm.backup_db"
            @on-change="dbChange"
            filterable>
          </transfer>
        </form-item>
      </i-form>
    </Modal>
    <Drawer
      v-model="backupLogModal"
      title="备份日志"
      :mask-closable="true"
      width="720">
      <p slot="header" style="color:#f60;">
        <Icon type="ios-information-circle"></Icon>
        <span>备份日志</span>
      </p>
      <div style="white-space: pre-line;">
        {{this.backupLog}}
      </div>
      <div slot="footer">
        <Button type="primary" size="large" long @click="closeLog()">Close</Button>
      </div>
    </Drawer>
    <Drawer
      :title="settingBackUpModalTitle"
      v-model="settingBackUpModal"
      width="600"
      :mask-closable="true"
      @on-close="settingBackUpCancel">
      <div>
        <i-form ref="settingBackUpForm" :model="settingBackUpForm" :label-width="100" :rules="settingBackUpRuleValidate">
          <form-item label="备份保留(天)" prop="retention_days">
            <InputNumber style="width:100%" v-model="settingBackUpForm.retention_days" placeholder=""></InputNumber>
          </form-item>
          <form-item label="备份方式" prop="backup_method">
            <Select style="" v-model="settingBackUpForm.backup_method">
              <Option :value=1 label="物理备份"></Option>
              <Option :value=2 label="逻辑备份"></Option>
            </Select>
          </form-item>
          <form-item label="备份时间" prop="backup_time">
            <TimePicker style="width:100%" v-model="settingBackUpForm.backup_time" format="HH:mm" placeholder="Select time" />
          </form-item>
          <form-item label="备份周期" prop="backup_period">
            <CheckboxGroup v-model="settingBackUpForm.backup_period">
              <Checkbox label='星期天'></Checkbox>
              <Checkbox label='星期一'></Checkbox>
              <Checkbox label='星期二'></Checkbox>
              <Checkbox label='星期三'></Checkbox>
              <Checkbox label='星期四'></Checkbox>
              <Checkbox label='星期五'></Checkbox>
              <Checkbox label='星期六'></Checkbox>
            </CheckboxGroup>
          </form-item>
          <form-item>
            <i-button type="primary" @click="backUpConfigSubmit">提交</i-button>
            <i-button style="margin-left: 8px" @click="settingBackUpCancel">取消</i-button>
          </form-item>
        </i-form>
      </div>
    </Drawer>
    <Card shadow>
      <Row>
        <i-col span="21">
          <h1>{{this.$route.query.name}}</h1>
        </i-col>
        <i-col span="3">
          <Button style="float: right;" @click="getDatabases" type="primary" :style="{marginBottom: '10px'}">备份实例</Button>
        </i-col>
      </Row>
      <Divider />
      <Row :gutter="18">
        <Col span="24" :md="6">
          <Card dis-hover style="height: 720px">
            <p slot="title">
              <Icon type="ios-settings"></Icon>
              备份设置
            </p>
            <div v-if="backConfig">
              <CellGroup>
                <Cell title="数据备份保留" selected><span slot="extra">{{backConfigData.retention_days}} 天</span></Cell>
                <Cell title="备份周期"><span slot="extra">{{backConfigData.backup_period}}</span></Cell>
                <Cell title="备份时间" selected ><span slot="extra">{{backConfigData.backup_time}}</span></Cell>
                <Cell title="备份方式">
                  <span slot="extra" v-if="backConfigData.backup_method === 1">物理备份</span>
                  <span slot="extra" v-else>逻辑备份</span>
                </Cell>
              </CellGroup>
              <Button long shape="circle" type="primary" @click="settingBackUp()">编辑</Button>
            </div>
            <div v-else>
              <Button long  shape="circle" type="primary" @click="settingBackUp()">设置</Button>
            </div>
          </Card>
        </Col>
        <Col span="24" :md="18" class="mob-mt-20">
          <Card dis-hover style="height: 720px">
            <p slot="title">
              <Icon type="ios-list"></Icon>
              备份列表
            </p>
            <DatePicker slot="extra" type="daterange" :value="dateValue" :options="dateOption" placement="bottom-end"
                        placeholder="Select date" @on-change="getBackUp"></DatePicker>
            <div>
              <tables ref="backUpTable" height="600" search-place="top" v-model="backUpData" :columns="backUpColumns" class="mob-remove-table-fixed"/>
              <Row style="margin: 10px;">
                <div style="float: right;">
                  <page :total="count" :current="page" :page-size="size" @on-change="getBackUp"></page>
                </div>
              </Row>
            </div>
          </Card>
        </Col>
      </Row>
    </Card>
  </div>
</template>

<script>
import Tables from '_c/tables'
import {getBackUpConfigList, pushBackUpConfig, getBackUpList, showDatabaseList, manualBackup, backupUrl, getBackUpLog} from '@/api/mysql'
import {getOpsCenterServer} from '@/api/opscenter'

export default {
  name: 'MySQLInstanceBackup',
  components: {
    Tables
  },
  data: function () {
    return {
      searchForm: {
        name: ''
      },
      listStyle: {
        width: '400px',
        height: '300px'
      },
      count: 1,
      size: 15,
      page: 1,
      databaseList: [],
      dateValue: [new Date(new Date().setDate(new Date().getDate() - 6)).toISOString().slice(0, 10), new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().slice(0, 10)],
      dateOption: {
        shortcuts: [
          {
            text: '今天',
            value () {
              const start = new Date()
              const end = new Date(new Date().setDate(new Date().getDate() + 1))
              return [start, end]
            }
          },
          {
            text: '三天',
            value () {
              const end = new Date(new Date().setDate(new Date().getDate() + 1))
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 2)
              return [start, end]
            }
          },
          {
            text: '一周',
            value () {
              const end = new Date(new Date().setDate(new Date().getDate() + 1))
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6)
              return [start, end]
            }
          },
          {
            text: '一个月',
            value () {
              const end = new Date(new Date().setDate(new Date().getDate() + 1))
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 29)
              return [start, end]
            }
          },
          {
            text: '三个月',
            value () {
              const end = new Date(new Date().setDate(new Date().getDate() + 1))
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 89)
              return [start, end]
            }
          }
        ]
      },
      is_superuser: false,
      // 手动备份
      manualBackupModal: false,
      manualBackupForm: {
        id: 0,
        certificate: {},
        backup_method: 1,
        backup_type: 1,
        backup_db: []
      },
      // 设置备份
      settingBackUpModal: false,
      settingBackUpModalTitle: '备份设置',
      settingBackUpForm: {
        instance: this.$route.query.id,
        backup_period: [],
        retention_days: null,
        backup_method: '',
        backup_time: ''
      },
      settingBackUpRuleValidate: {
        retention_days: {required: true, type: 'number', message: '请输入备份保留天数', trigger: 'blur'},
        backup_method: {required: true, type: 'number', message: '请选择备份方式', trigger: 'blur'},
        backup_time: {required: true, type: 'string', message: '请选择备份时间', trigger: 'blur'},
        backup_period: {required: true, type: 'array', min: 1, message: '请选择备份周期', trigger: 'blur'}
      },
      // 备份日志
      backupLogModal: false,
      backupLog: '',
      // 备份列表
      certificate: {},
      backConfig: false,
      backUpData: [],
      backConfigData: {},
      backUpColumns: [
        // {title: '备份名称', key: 'backup_name', align: 'center', width: 150},
        {title: '开始时间',
          key: 'start_time',
          align: 'center',
          minWidth: 175,
          render: (h, params) => {
            return h('div', new Date(params.row.start_time).toLocaleString())
          }
        },
        {title: '结束时间',
          key: 'end_time',
          align: 'center',
          minWidth: 175,
          render: (h, params) => {
            return h('div', new Date(params.row.end_time).toLocaleString())
          }
        },
        {title: '备份大小',
          key: 'backup_size',
          align: 'center',
          minWidth: 100,
          render: (h, params) => {
            return h('div', this.formatSizeUnits(params.row.backup_size))
          }
        },
        {title: '备份方式',
          key: 'backup_method',
          align: 'center',
          minWidth: 100,
          render: (h, params) => {
            if (params.row.backup_method === 1) {
              return h('div', '物理备份')
            } else {
              return h('div', '逻辑备份')
            }
          }
        },
        {title: '备份类型',
          key: 'backup_type',
          align: 'center',
          minWidth: 100,
          render: (h, params) => {
            if (params.row.backup_type === 1) {
              return h('div', '实例备份')
            } else {
              return h('div', ['单库备份',
                h('Tooltip', {
                  props: {
                    content: params.row.backup_db,
                    placement: 'top',
                    'max-width': 200
                  }
                },
                [
                  h('Icon', {
                    props: {
                      type: 'md-help-circle',
                      size: 16
                    }
                  })
                ]
                )
              ])
            }
          }
        },
        {title: '状态',
          key: 'backup_status',
          align: 'center',
          minWidth: 100,
          render: (h, params) => {
            if (params.row.backup_status === 1) {
              return h('div', '备份成功')
            } else if (params.row.backup_status === 2) {
              return h('div', '备份运行中')
            } else {
              return h('div', '备份失败')
            }
          }
        },
        {title: '操作',
          fixed: 'right',
          align: 'center',
          minWidth: 150,
          render: (h, params) => {
            if (this.$store.state.user.superuser) {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'info',
                    size: 'small'
                  },
                  style: {
                    marginLeft: '5px'
                  },
                  on: {
                    click: () => {
                      this.showBackupLog(params.row.id)
                    }
                  }
                },
                [
                  h('div', '日志')
                ]
                ),
                h('Poptip', {
                  props: {
                    confirm: true,
                    placement: 'bottom',
                    title: '你确定要下载吗?'
                  },
                  on: {
                    'on-ok': () => {
                      this.getBackupUrl(this.$route.query.id, params.row.id)
                    }
                  }
                }, [h('Button', {
                  props: {
                    type: 'success',
                    size: 'small'
                  },
                  style: {
                    marginLeft: '5px'
                  }
                },
                [
                  h('div', '下载')
                ]
                )]
                )
                // h('Button', {
                //     props: {
                //       type: 'error',
                //       size: 'small'
                //     },
                //     style:{
                //       marginLeft: '5px'
                //     },
                //     on: {
                //       click: () => {
                //         console.log(params)
                //       }
                //     }
                //   },
                //   [
                //     h('div', '恢复')
                //   ]
                // ),
              ]
              )
            }
          }
        }
      ]
    }
  },

  watch: {
    '$route' (to, from) {
      // 对路由变化作出响应...
      if (this.$route.query.id) {
        this.refresh()
      }
    }
  },

  methods: {
    refresh () {
      this.getBackUpConfig()
      this.getBackUp()
    },

    closeLog () {
      this.backupLogModal = false
    },

    settingBackUpCancel () {
      this.settingBackUpForm.instance = null
      this.settingBackUpForm.backup_period = []
      this.settingBackUpForm.retention_days = null
      this.settingBackUpForm.backup_method = null
      this.settingBackUpForm.backup_time = ''
      this.settingBackUpModal = false
    },
    settingBackUp () {
      if (this.backConfigData) {
        this.settingBackUpForm.instance = this.$route.query.id
        this.settingBackUpForm.id = this.backConfigData.id
        this.settingBackUpForm.backup_period = this.backConfigData.backup_period.split(',')
        this.settingBackUpForm.retention_days = this.backConfigData.retention_days
        this.settingBackUpForm.backup_method = this.backConfigData.backup_method
        this.settingBackUpForm.backup_time = this.backConfigData.backup_time
      }
      this.settingBackUpModal = true
      this.settingBackUpForm.instance = this.$route.query.id
    },
    getBackUpConfig () {
      let params = {
        instance_id: this.$route.query.id
      }
      getBackUpConfigList(params).then(res => {
        this.backConfigData = res.data.results[0]
        this.backConfig = res.data.count !== 0
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '获取实例列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取实例列表失败！服务器无响应'
          })
        }
      })
    },
    backUpConfigSubmit () {
      this.$refs['settingBackUpForm'].validate((valid) => {
        if (valid) {
          pushBackUpConfig(this.settingBackUpForm, this.settingBackUpForm.id).then(res => {
            this.$Notice.success({
              title: '操作成功！'
            })
            this.settingBackUpCancel()
            this.getBackUpConfig()
          }).catch(res => {
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！服务器无响应'
              })
            }
          })
        }
      })
    },
    getBackUp (value = 1) {
      if (typeof value === 'number') {
        this.page = value
      } else {
        let end = new Date(value[1])
        end.setTime(end.getTime() + 3600 * 1000 * 24)
        this.dateValue[0] = value[0]
        this.dateValue[1] = end.toISOString().slice(0, 10)
      }
      let params = {
        instance_id: this.$route.query.id,
        page: this.page,
        size: this.size,
        start_time__gt: this.dateValue[0],
        start_time__lt: this.dateValue[1]
      }
      getBackUpList(params).then(res => {
        this.backUpData = res.data.results
        this.count = res.data.count
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '获取实例列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取实例列表失败！服务器无响应'
          })
        }
      })
    },
    get_certificate () {
      let params = {
        inner_ip: this.$route.params.server
      }
      getOpsCenterServer(params).then(res => {
        this.certificate = res.data.results[0].certificate
      })
    },
    getDatabases () {
      this.manualBackupModal = true
      let params = {
        id: this.$route.query.id
      }
      let that = this
      that.databaseList = []
      showDatabaseList(params).then(res => {
        if (res.status === 200) {
          let result = res.data.results
          for (let i in result) {
            that.databaseList.push({
              key: result[i],
              label: result[i]
            })
          }
        }
      })
    },
    dbChange (newTargetKeys) {
      this.manualBackupForm.backup_db = newTargetKeys
    },
    manualBackupCancel () {
      this.manualBackupForm.id = 0
      this.manualBackupForm.certificate = {}
      this.manualBackupForm.backup_method = 1
      this.manualBackupForm.backup_type = 1
      this.manualBackupForm.backup_db = []
    },
    manualBackupSubmit () {
      if (this.manualBackupForm.backup_db.length === 0 && this.manualBackupForm.backup_type === 2) {
        this.$Notice.error({
          title: '请选择数据库'
        })
      } else {
        this.manualBackupForm.certificate = this.certificate
        this.manualBackupForm.id = this.$route.query.id
        this.$refs['manualBackupForm'].validate((valid) => {
          if (valid) {
            manualBackup(this.manualBackupForm).then(res => {
              this.$Notice.success({
                title: '操作成功！'
              })
              this.manualBackupCancel()
              this.getBackUp()
            }).catch(res => {
              if (res.request) {
                this.$Notice.error({
                  title: '操作失败！请求状态码:' + res.request.status,
                  desc: res.request.responseText
                })
              } else {
                this.$Notice.error({
                  title: '操作失败！服务器无响应'
                })
              }
            })
          }
        })
      }
    },
    formatSizeUnits (bytes) {
      if (bytes >= 1073741824) {
        bytes = (bytes / 1073741824).toFixed(2) + ' GB'
      } else if (bytes >= 1048576) {
        bytes = (bytes / 1048576).toFixed(2) + ' MB'
      } else if (bytes >= 1024) {
        bytes = (bytes / 1024).toFixed(2) + ' KB'
      } else if (bytes > 1) {
        bytes = bytes + ' bytes'
      } else if (bytes === 1) {
        bytes = bytes + ' byte'
      } else {
        bytes = '0 bytes'
      }
      return bytes
    },

    getBackupUrl (instanceId, backupId) {
      let data = {
        instance_id: instanceId,
        backup_id: backupId
      }
      backupUrl(data).then(res => {
        location.href = res.data.results
        this.$Notice.success({
          title: '操作成功！'
        })
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    },

    showBackupLog (id) {
      let params = {
        backup_info_id: id
      }
      getBackUpLog(params).then(res => {
        this.backupLog = res.data.results[0].content
        this.backupLogModal = true
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    }
  },
  mounted: function () {
    this.getBackUpConfig()
    this.getBackUp()
    this.get_certificate()
  }
}
</script>
<style lang="less">
 @media screen and (max-width:640px) {
  .mysql-instanceBackup-page{
    .ivu-card-bordered,.ivu-table-wrapper{
      height:initial!important;
    }
    h1{
      font-size: 1.5em;
    }
    .ivu-divider-horizontal{
     margin:10px 0 15px;
    }
  }
}
</style>
